import { Td, Tr } from "@chakra-ui/react";
import { ScenarioModel } from "../../clients/BackOfficeApi";
import { LinkButton } from "../../elements/LinkButton";
import { ScenarioActions } from "./ScenarioActions";
import { VisibilityIcon } from "../../elements/VisibilityIcon";

interface Props {
  scenario: ScenarioModel;
  includeSituationDetails?: boolean;
  onChange?: () => void;
}

export function ScenarioListRow({
  scenario,
  includeSituationDetails = false,
  onChange = () => {},
}: Props) {
  return (
    <Tr key={scenario.id}>
      <Td>{scenario.name}</Td>
      {includeSituationDetails && (
        <>
          <Td>
            <LinkButton to={`/residence-types/${scenario.residenceTypeId}`}>
              {scenario.residenceTypeName}
            </LinkButton>
          </Td>
          <Td>
            <LinkButton to={`/situations/${scenario.situationId}`}>
              {scenario.orientation} | {scenario.relativePosition}
            </LinkButton>
          </Td>
        </>
      )}
      <Td>
        <VisibilityIcon visibility={scenario.visibility} />
      </Td>
      <Td>
        <ScenarioActions forCell onChange={onChange} scenario={scenario} />
      </Td>
    </Tr>
  );
}
